import { Link } from "react-router-dom";
import { CreditCard, FileBadge2, IdCard, User } from "lucide-react";

// Audit P1 portal-dashboard residual — the audit flagged that the
// dashboard offers no surfaces for the four most-asked-about portal
// actions: paying / seeing invoices, uploading the rental's COI,
// adding photo IDs, and editing profile. Each one lives behind a
// "My account" link the customer has to discover first. This rail
// puts them at the dashboard's top edge, brand-red iconography,
// 44-tall touch targets for mobile.
interface RailTile {
  href: string;
  label: string;
  hint: string;
  icon: typeof CreditCard;
}

const TILES: RailTile[] = [
  {
    href: "/portal/account/billing",
    label: "Billing",
    hint: "Invoices · cards",
    icon: CreditCard,
  },
  {
    href: "/account/coi",
    label: "COI",
    hint: "Upload · status",
    icon: FileBadge2,
  },
  {
    href: "/portal/account/ids",
    label: "IDs",
    hint: "Photo ID on file",
    icon: IdCard,
  },
  {
    href: "/portal/profile",
    label: "Profile",
    hint: "Contact · addresses",
    icon: User,
  },
];

export function QuickAccessRail(): JSX.Element {
  return (
    <nav
      aria-label="Quick access"
      data-testid="quick-access-rail"
      className="grid grid-cols-2 gap-3 sm:grid-cols-4"
    >
      {TILES.map(({ href, label, hint, icon: Icon }) => (
        <Link
          key={href}
          to={href}
          className="group flex min-h-[44px] items-center gap-3 rounded-lg border border-zinc-200 bg-brand-white px-3 py-2 shadow-sm transition hover:-translate-y-0.5 hover:border-brand-red/40 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2"
        >
          <span className="grid h-9 w-9 flex-none place-items-center rounded-full bg-brand-red/10 text-brand-red transition group-hover:bg-brand-red group-hover:text-brand-white">
            <Icon aria-hidden="true" className="h-4 w-4" />
          </span>
          <span className="min-w-0">
            <span className="block truncate text-sm font-semibold text-brand-black">
              {label}
            </span>
            <span className="block truncate text-xs text-zinc-500">{hint}</span>
          </span>
        </Link>
      ))}
    </nav>
  );
}
